import React, { useEffect } from "react";
import { Link } from "react-router-dom";

export const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-content">
          <div className="legal-header">
            <h1 className="legal-title">Privacy Policy</h1>
            <p className="legal-subtitle">Effective Date: September 1, 2025</p>
          </div>

          <div className="legal-section">
            <p>
              Peak Risk Management, LLC (“Peak Risk,” “we,” “our,” or “us”)
              respects your privacy and is committed to protecting it through
              this Privacy Policy. This document outlines how we collect, use,
              protect, and disclose personal information through our website and
              services.
            </p>
          </div>

          <div className="legal-section">
            <h2>Scope of This Policy</h2>
            <p>This Privacy Policy applies to:</p>
            <ul>
              <li>Visitors to our website at [Insert Website URL]</li>
              <li>
                Users of our software-as-a-service platform and related services
              </li>
              <li>
                Individuals whose data is submitted to us by our customers
              </li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>Information We Collect</h2>
            <p>We may collect the following types of information:</p>
            <ul>
              <li>
                <strong>Personal Information:</strong> Name, email address,
                company name, phone number, job title, and other identifiers you
                provide.
              </li>
              <li>
                <strong>Usage Data:</strong> IP address, browser type, device
                information, pages visited, and referring URLs.
              </li>
              <li>
                <strong>Submitted Data:</strong> Incident reports, claims,
                safety forms, and policy documents submitted by users or
                customers.
              </li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
              <li>Provide and improve our services</li>
              <li>Respond to inquiries and support requests</li>
              <li>Communicate updates and relevant content</li>
              <li>Analyze usage trends and optimize performance</li>
              <li>Comply with legal obligations</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>Cookies and Tracking Technologies</h2>
            <p>
              Our website may use cookies and similar technologies to enhance
              user experience and analyze traffic. You may manage cookie
              preferences through your browser settings.
            </p>
          </div>

          <div className="legal-section">
            <h2>Disclosure of Information</h2>
            <p>We do not sell your personal information. We may share data with:</p>
            <ul>
              <li>
                Trusted third-party service providers (e.g., hosting, analytics,
                support tools)
              </li>
              <li>Legal authorities when required by law</li>
              <li>
                Customers who have submitted your data through our platform
              </li>
            </ul>
            <p>
              All third-party providers are bound by confidentiality and data
              protection agreements.
            </p>
          </div>

          <div className="legal-section">
            <h2>Data Security</h2>
            <p>
              We implement industry-standard security measures to protect your
              data. While no system is completely secure, we strive to safeguard
              your information through encryption, access controls, and secure
              infrastructure.
            </p>
          </div>

          <div className="legal-section">
            <h2>Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access, correct, or delete your personal information</li>
              <li>Opt out of marketing communications</li>
              <li>Request data removal (“right to be forgotten”)</li>
              <li>Withdraw consent where applicable</li>
            </ul>
            <p>
              To exercise these rights, contact us at [Insert Contact Email].
            </p>
          </div>

          <div className="legal-section">
            <h2>Third-Party Links</h2>
            <p>
              Our website may contain links to external sites. We are not
              responsible for the privacy practices or content of those sites.
            </p>
          </div>

          <div className="legal-section">
            <h2>Children’s Privacy</h2>
            <p>
              Our services are not intended for individuals under the age of 13.
              We do not knowingly collect personal data from children.
            </p>
          </div>

          <div className="legal-section">
            <h2>Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy periodically. Changes will be
              posted on this page with an updated effective date. Continued use
              of our website or services indicates acceptance of the revised
              policy.
            </p>
          </div>

          <div className="legal-contact">
            <p>
              If you have questions or concerns about this Privacy Policy,
              please contact:
            </p>
            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:support@peakrmis.com">support@peakrmis.com</a>
              <br />
              <strong>Company:</strong> Peak Risk Management, LLC
            </p>
          </div>

          <div className="legal-back-button">
            <Link to="/" className="btn btn-primary">
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
